import { render } from "./multiUpload.vue?vue&type=template&id=22a85865&scoped=true"
import script from "./multiUpload.vue?vue&type=script&lang=js"
export * from "./multiUpload.vue?vue&type=script&lang=js"

import "./multiUpload.vue?vue&type=style&index=0&id=22a85865&scoped=true&lang=css"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a85865"]])

export default __exports__